<!-- 设备管理 -->
<template>
  <a-card :bordered="false">
    <a-tabs @change="changeTab">
      <a-tab-pane key="1" :tab="$t('数据列表')">
        <DataList ref="dataList" />
      </a-tab-pane>
      <a-tab-pane key="2" :tab="$t('地图展示')">
        <MapList ref="mapList" />
      </a-tab-pane>
    </a-tabs>
  </a-card>
</template>

<script>
  import DataList from './dataList.vue'
  import MapList from './mapList.vue'

  export default {
    name: 'lineList',
    components: {
      DataList,
      MapList
    },
    data () {
      return {
        url: {
          list: "/jeecg-engineering/inspection/inspectionDevice/list",
          delete: "/jeecg-engineering/inspection/inspectionDevice/delete",
          deleteBatch: "/jeecg-engineering/inspection/inspectionDevice/deleteBatch",
          exportXlsUrl: "/jeecg-engineering/ticket/tickets/exportXls",
          importExcelUrl: "jeecg-engineering/ticket/tickets/importExcel",
        },
        dictOptions:{},
        superFieldList:[],
      }
    },
    created() {},
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      description() {
        return this.$t('设备管理页面')
      },
      // 表头
      columns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender: (t,r,index) => {
              return parseInt(index)+1;
            }
          },
          {
            title: this.$t('设备编号'),
            align:"center",
            dataIndex: 'deviceNum'
          },
          {
            title: this.$t('设备名称'),
            align:"center",
            dataIndex: 'deviceName'
          },
          {
            title: this.$t('设备类型'),
            align:"center",
            dataIndex: 'deviceType',
            customRender: (text) => {
              return filterDictTextByCache('deviceType', text)
            }
          },
          {
            title: this.$t('设备描述'),
            align:"center",
            dataIndex: 'deviceDetail'
          },
          // {
          //   title:'设备经度',
          //   align:"center",
          //   dataIndex: 'detectLongitude'
          // },
          // {
          //   title:'设备纬度',
          //   align:"center",
          //   dataIndex: 'detectLatitude'
          // },
          // {
          //   title:'备注',
          //   align:"center",
          //   dataIndex: 'remark'
          // },
          {
            title: this.$t('操作'),
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:150,
            scopedSlots: { customRender: 'action' }
          }
        ]
      },
    },
    methods: {
      // 详情
      // handleDetail(row){
      //   this.$nextTick(()=>{
      //     this.$refs.modalForm.init(row);
      //   })
      // },
      handleHistory(row){
        this.$nextTick(()=>{
          this.$refs.historyForm.init(row);
        })
      },
      changeTab(e){
        if(e==2){
          this.$refs.mapList.searchReset();
        }else{
          this.$refs.dataList.searchReset();
        }
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>